var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c("b-col", { staticClass: "ml-2" }, [
        _vm.editingFileName
          ? _c(
              "div",
              { staticClass: "form-group-material mb-0 editable-description" },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.localFileName,
                      expression: "localFileName",
                    },
                  ],
                  staticClass:
                    "material-input form-control material-input-static-label form my-1 moregage-data w-25",
                  attrs: { type: "text" },
                  domProps: { value: _vm.localFileName },
                  on: {
                    focusout: _vm.handleEditDocument,
                    keydown: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.handleEditDocument.apply(null, arguments)
                    },
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.localFileName = $event.target.value
                    },
                  },
                }),
              ]
            )
          : _c(
              "p",
              {
                staticClass:
                  "text-left text-primary mb-0 clickable preview-document",
                on: { click: _vm.handlePreviewClick },
              },
              [
                _vm.loadingPreview
                  ? _c("inline-loader", { staticClass: "mr-1" })
                  : _vm._e(),
                _vm._v("\n      " + _vm._s(_vm.fileName) + "\n    "),
              ],
              1
            ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("p", { staticClass: "text-left date text-gray mb-1" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm._f("toUploadHour")(_vm.createdAt)) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c("document-row-toolbar", {
              attrs: {
                "is-sample": true,
                downloading: _vm.downloading,
                deleting: _vm.deleting,
                move: false,
              },
              on: {
                download: _vm.handleDownloadDocument,
                edit: _vm.toggleRenameDocument,
                delete: _vm.handleDeleteDocument,
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("document-preview-modal", {
        ref: "previewDocumentModal",
        attrs: {
          "file-name": _vm.fileName,
          "document-id": _vm.documentId,
          url: _vm.previewDocumentUrl,
          "document-is-downloading": _vm.downloading,
        },
        on: {
          "download-document": _vm.handleDownloadDocument,
          hide: _vm.handlePreviewDocumentModalHide,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }